import type { Slider as SliderNS } from 'radix-ui';

import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from './styles';

export interface IBaseSliderProps extends SliderNS.SliderProps {
  dataCy?: string;
}

export const BaseSlider = ({
  dataCy = 'slider-field',
  ...props
}: IBaseSliderProps): JSX.Element => {
  return (
    <SliderRoot data-cy={dataCy} {...props}>
      <SliderTrack>
        <SliderRange />
      </SliderTrack>
      <SliderThumb />
    </SliderRoot>
  );
};
